import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.scss']
})
export class AdministrationComponent implements OnInit {

  administrationItems;

  constructor() {
    this.administrationItems = [
      {routerLink: 'license', name: 'License'},
      {routerLink: 'security', name: 'Security'},
      {routerLink: 'configuratorCertificate', name: 'Configurator Certificate'},
      {routerLink: 'operators', name: 'Operators'},
      {routerLink: 'securityPolicies', name: 'Security Policies'},
      {routerLink: 'nodeCredentials', name: 'Node Credentials'},
      {routerLink: 'routerCredentials', name: 'Router Credentials'},
      {routerLink: 'configuratorCredentials', name: 'Configurator Credentials'},
      {routerLink: 'ldapAuthentication', name: 'LDAP Authentication'},
      {routerLink: 'radiusAuthentication', name: 'RADIUS Authentication'},
      {routerLink: 'azureAuthentication', name: 'Azure Authentication'},
      {routerLink: 'remoteManager', name: 'Remote Manager'},
      {routerLink: 'certificates', name: 'Trusted Certificates'},
      {routerLink: 'analytics', name: 'Analytics'}
    ];
  }

  ngOnInit(): void {
  }

}
